import React from 'react';

const AdminContext = React.createContext({});

export default AdminContext;
